import { NavigateFunction } from 'react-router-dom';

import { IDeepLink } from '@gem/models/deeplinksModel';

import Tasks from 'APP/Tasks';
import { StickerPackPopup } from 'APP/main/PopupManager/Popups/StickerPackPopup/StickerPackPopup';
import { RouterParams, RouterState } from 'APP/router/constants';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

interface IHandleDeepLinkParams {
  link?: string;
  // Todo Replace to the return data type of navigateTo hook when they will be refactored
  navigateTo: NavigateFunction;
  state?: Record<string, any>;
  deepLinkParams?: IDeepLink | null;
}

export async function handleDeepLink(data: IHandleDeepLinkParams): Promise<Group | null> {
  const { link, navigateTo, state = {}, deepLinkParams } = data;

  const params = await Tasks.deeplinks.getParamsByDeepLink({ link, deepLink: deepLinkParams });
  if (!params) {
    return null;
  }

  const {
    messageId,
    stickerPackId,
    groupId,
    userId,
    isAlreadyJoined,
    spaceRoute,
    spaceId,
    channelId,
  } = params;

  let group = groupId ? Entities.GroupsStore.getGroupById(groupId) : null;

  if (messageId && group) {
    Tasks.messaging.focusMessage({ groupId: group.id, messageId });
  }

  if (channelId) {
    if (Entities.Calls.ongoingCall) {
      const result = await Tasks.calls.askAndDeleteActiveCall();
      if (result) {
        navigateTo(`?${RouterParams.roomCallChannelId}=${channelId}`, { replace: true });
      }
    } else {
      navigateTo(`?${RouterParams.roomCallChannelId}=${channelId}`);
    }
  }

  if (groupId && group) {
    await Tasks.group.setActiveGroup({ groupId, state });
    if (spaceId) {
      await Tasks.space.setActiveSpace(spaceId);
    }
  }

  if (group && isAlreadyJoined) {
    Tasks.calls.findGroupCallAndRun(group.id);
  }

  if (group && !isAlreadyJoined) {
    group.setIsAwaitCall(true);
  }

  if (stickerPackId) {
    Tasks.app.openPopup(StickerPackPopup, { params: { stickerPackId } });
  }

  if (userId) {
    const me = Entities.usersStore.Me;
    if (me?.id === userId) {
      group = await Tasks.group.goToSavedMessages(state);
    } else {
      group = await Tasks.group.createP2PGroup(userId);
    }
  }

  if (spaceRoute) {
    navigateTo(spaceRoute, { state: { [RouterState.fromDeepLink]: true } });
  }

  return group;
}
